require('./browseFileModal.scss');

class BrowseFileModal {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
  }

  $onInit() {
    this.modalHeaderTitle = this.resolve.modalHeaderTitle;
    this.browseLabel = this.resolve.browseLabel;
    this.originalFileName = this.resolve.content?.name;
    this.filenameChangedWarning =
      'Je document heeft een nieuwe naam waardoor de bestaande link naar dit document niet meer zal werken. Wil je de link toch behouden (bv. omdat deze gedeeld werd via de nieuwsbrief), behoud dan je oude bestandsnaam';
    angular
      .element(document.querySelector('#uploadFile'))
      .on('change', this.handleUploadFileSelect.bind(this));
  }

  clickBrowseForUpload() {
    angular.element(document.querySelector('#uploadFile')).click();
  }

  async handleUploadFileSelect(event) {
    this.file = event.target.files[0];
    this.hasFilenameChanged =
      this.file.name &&
      this.resolve.content &&
      this.file.name.replace(/ /g, '_') !== this.resolve.content.name?.replace(/ /g, '_') &&
      this.file.name !== this.resolve.content.originalName;
    this.$scope.$apply();
  }

  submit() {
    this.close({ $value: this.file });
  }

  cancel() {
    this.dismiss();
  }
}

export const browseFileModalComponent = {
  template: require('./browseFileModal.html'),
  controllerAs: 'ctrl',
  controller: BrowseFileModal,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};
